module.exports = __webpack_public_path__ + "img/1440.e5c95871.jpg";